import request from '../../../server/request';

export const getActiveSchoolYears=(data)=>{
  return request({
    url: `mealManage/dashboard/schoolYears?systemDate=${data.sysDate}`,
    method: 'get'
  });
}
export const getActiveStudentsBySchoolYear=(data)=>{
  return request({
    url: `mealManage/dashboard/stdCount?schoolYear=${data.schoolYear}`,
    method: 'get'
  });
}
export const getTotalMeal_Alacarte_Transactions_revnueData=(data)=>{
  return request({
    url: `mealManage/dashboard/summaryData/${data.schoolYear}?startDate=${data.startDate}&endDate=${data.endDate}`,
    method: 'get'
  });
}
export const getTotalMeal_Alacarte_Transactions_revnueDataBySchoolYear=(data)=>{
  return request({
    url: `mealManage/dashboard/summaryData/${data.schoolYear}`,
    method: 'get'
  });
}


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/dashboardItemsService.js